import React from 'react'
import { FAIcon } from './FAIcon'
import _ from 'common-tools/LodashHelper'

export class CatchError extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      info: null
    }
  }

  static getDerivedStateFromError (error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch (error, info) {
    this.setState({
      hasError: true,
      error: error,
      info: info
    })
  }

  renderError () {
    const { close } = this.props

    let closeAction = null
    if (_.isFunction(close)) {
      closeAction = <FAIcon style={{ cursor: 'pointer' }} name='times' toolTip='Close Drawer' onClick={() => { close() }} />
    }

    const { error, info } = this.state
    return <div className='text-center'>
      <h3>Error <FAIcon style={{ cursor: 'pointer' }} name='redo' toolTip='Try to reload' onClick={() => { this.setState({ hasError: false, error: null, info: null }) }} /> {closeAction}</h3>
      <p><b>Message</b></p>
      <p>{(error || {}).message}</p>
      <p><b>Stack Trace</b></p>
      <p>{(error || {}).stack}</p>
      <p><b>Component Trace</b></p>
      <p>{(info || {}).componentStack}</p>
    </div>
  }

  render () {
    const { children } = this.props
    const { hasError } = this.state

    if (hasError) {
      return this.renderError()
    }

    return children
  }
}
